<div [ngClass]="customClass" class="export-icon-btn" [class.disabled]="downloading" (click)="handleClick()" [matTooltip]="tooltip">
  <i class="material-icons">{{ downloading ? "hourglass_empty" : "cloud_download" }}</i>
</div>
